import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {

  constructor(private metaService: MetaService) { }

  ngOnInit() {
    this.metaService.setTitle("Seeguide.at | Badeplätze und Restaurants am Attersee")
    this.metaService.setTags("Attersee, Badeplätze, Restaurants, Ausflüge, Unterkünfte, Tipps, Urlaub, Baden, Strand, Essen, Geheimtip, Forum, Seeguide, Litzlberg, Seewalchen, Weyregg, Unterach", "Verzeichnis mit den besten Badeplätzen, Restaurants, Ausflügen und Unterkünfte rund um den Attersee. Mit viele schöne Fotos und Insider-Tipps im Forum.");
  }
}
